module.exports = __webpack_public_path__ + "img/download1.804a974c.png";